module.exports = __webpack_public_path__ + "static/img/APNLogo.2375c6c5.png";